import { capitalize } from './capitalize';

export function camelCase(str = '') {
  const words = str.match(/[$\w]+/g) ?? [];
  const first = words[0];
  const nextWords = words.slice(1);

  return nextWords.reduce((acc, cur) => {
    return acc + capitalize(cur);
  }, first);
}
